import { z } from "zod/v4";

import { CustomEventDtoSchema } from "./analytics-events/custom-events";

export const ExperienceCustomMetricDtoSchema = z.object({
  id: z.uuid().describe("Unique identifier for the custom metric"),
  experienceId: z.uuid().describe("Experience this metric belongs to"),
  order: z.number().describe("Display order in analytics dashboard"),
  customEventId: z
    .uuid()
    .describe("ID of custom event defined in your analytics"),
  customEvent: CustomEventDtoSchema.describe(
    "Custom event configuration and details"
  ),
});

export type ExperienceCustomMetricDto = z.infer<
  typeof ExperienceCustomMetricDtoSchema
>;

export const CreateExperienceCustomMetricDtoSchema =
  ExperienceCustomMetricDtoSchema.omit({
    customEvent: true,
  }).extend({
    experienceId: z
      .uuid()
      .optional()
      .describe("Experience ID (optional when creating with experience)"),
  });

export type CreateExperienceCustomMetricDto = z.infer<
  typeof CreateExperienceCustomMetricDtoSchema
>;
